import { useTranslation } from 'react-i18next';

import { Dialog, DialogActions } from '@/components/molecules/dialog';
import { useRemoveDestination } from '@/features/destinations/hooks/mutation/use-remove-destination';

interface Props extends DialogActions {
  destinationId: number;
  destinationName: string;
  destinationHasAvailableKiosks: boolean;
}

const RemoveDestinationDialog = ({
  open,
  onCancel,
  destinationId,
  destinationName,
  destinationHasAvailableKiosks,
}: Props) => {
  const { t } = useTranslation(['destinations']);

  const { mutate } = useRemoveDestination(onCancel);

  return (
    <Dialog
      open={open}
      onCancel={onCancel}
      title={`${t('destinations:modalDelete.title')} ${destinationName}`}
      onConfirm={() => mutate(destinationId)}
      variant="warning">
      {t('destinations:modalDelete.message') +
        (destinationHasAvailableKiosks
          ? ' ' + t('destinations:modalDelete.kioskAvailableMessage')
          : '')}
    </Dialog>
  );
};

export default RemoveDestinationDialog;
